import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';
import lang from './assets/lang';
import Layout from './components/layout/Layout';
import { About, Blog, Contact, JoinUs, Services, SinglePost } from './pages';
import Home from './pages/Home';
import { initJqueyrPlugins } from './config/utility';
import PrivacyPolicy from './pages/PrivacyPolicy';
import ReturnPolicy from './pages/ReturnPolicy';
import ServiceTerms from './pages/ServiceTerms';
import HabitTrackerPrivacyPolicy from "./pages/HabitTrackerPrivacyPolicy";

class App extends Component {

  state = {
    activeLanguage: 'EN'
  };

  componentDidMount() {
    initJqueyrPlugins();
  }

  componentDidUpdate() {
    initJqueyrPlugins();
  }

  changeLanguageHandler = (activeLanguage) => {
    lang.setLanguage(activeLanguage);
    this.setState({ activeLanguage: activeLanguage });
  };

  render() {
    return (
      <Layout
        changeLanguage={this.changeLanguageHandler}
        activeLanguage={this.state.activeLanguage}
      >
        <Switch>
          <Route path="/" exact component={Home} />
          <Route path="/about" component={About} />
          <Route path="/blog/:postId" component={SinglePost} />
          <Route path="/blog" component={Blog} />
          <Route path="/services" component={Services} />
          <Route path="/contact" component={Contact} />
          <Route path="/join-us" component={JoinUs} />
          <Route path="/service-terms" component={ServiceTerms} />
          <Route path="/privacy-policy" component={PrivacyPolicy} />
          <Route path="/return-policy" component={ReturnPolicy} />
          <Route path="/habit-tracker/privacy-policy" component={HabitTrackerPrivacyPolicy} />
        </Switch>
      </Layout>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js